<template>
    <DsCard>
        <DsClosablePage
            :primaryButtonDisabled="primaryDisabled"
            :primaryButtonLoading="primaryLoading"
            :primaryButtonText="primaryAction"
            :secondaryButtonText="secondaryAction"
            :title="title"
        >
            <div class="ds-grid-span-full flex flex-col gap-3">
                <label class="col-span-2 grid gap-1">
                    Title
                    <input v-model="title" />
                </label>
                <label class="grid gap-1">
                    Primary button text
                    <input v-model="primaryAction" />
                </label>
                <label class="grid gap-1">
                    Secondary button text
                    <input v-model="secondaryAction" />
                </label>
                <DsCheckbox
                    v-model="primaryDisabled"
                    label="Disable primary action"
                    name="primaryDisabled"
                    value="true"
                />
                <DsCheckbox
                    v-model="primaryLoading"
                    label="Set primary action loading"
                    name="primaryLoading"
                    value="true"
                />
            </div>
        </DsClosablePage>
    </DsCard>
</template>

<script setup lang="ts">
import DsCard from '@/components/design-system/DsCard.vue';
import DsClosablePage from '@/components/design-system/DsClosablePage.vue';
import DsCheckbox from '@/components/design-system/form/input/DsCheckbox.vue';
import { ref } from 'vue';

const title = ref('Closable page');
const primaryAction = ref('Primary action');
const secondaryAction = ref('Secondary action');
const primaryDisabled = ref(false);
const primaryLoading = ref(false);
</script>
